import { CronJobApi } from "./automation-cron";
import { HookApi } from "./automation-hook";
import { AutomationMarketplaceApi } from "./automation-marketplace";
import { AutomationShareApi } from "./automation-share";
import { WebhookApi } from "./automation-webhook";
import type { ApiClient } from "./client";

// NOTE: Facade class that composes all automation domain APIs
export class AutomationApi {
  readonly cronJobs: CronJobApi;
  readonly webhooks: WebhookApi;
  readonly hooks: HookApi;
  readonly shares: AutomationShareApi;
  readonly marketplace: AutomationMarketplaceApi;

  constructor(apiClient: ApiClient) {
    this.cronJobs = new CronJobApi(apiClient);
    this.webhooks = new WebhookApi(apiClient);
    this.hooks = new HookApi(apiClient);
    this.shares = new AutomationShareApi(apiClient);
    this.marketplace = new AutomationMarketplaceApi(apiClient);
  }
}

export type {
  IGetCronJobRunsProps,
  IGetHookRunsProps,
  IGetRunDetailProps,
  IGetWebhookRunsProps,
  IUpdateCronJobProps,
  IUpdateHookProps,
  IUpdateWebhookProps,
  IUseGetRunDetailOptions,
  IUseGetRunDetailProps,
  TAnyRunDetail,
} from "./automation.types";
export { CronJobApi } from "./automation-cron";
export { HookApi } from "./automation-hook";
export { AutomationMarketplaceApi } from "./automation-marketplace";
export { AutomationShareApi } from "./automation-share";
export { WebhookApi } from "./automation-webhook";
